import React, { FC, useState, useEffect } from 'react';
import s from './SiteIframe.scss';
import { useViewport } from '../../../../hooks/useViewport';
import { Box } from '@wix/design-system';
import { SphereLoader } from 'bft-ui-lib';

export interface SiteIframeProps {
  storeName?: string;
  src?: string;
}

const LOADING_TIME = 10000;

export const SiteIframe: FC<SiteIframeProps> = ({ storeName = 'Your Store', src }) => {
  const { isMobile } = useViewport();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (src) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, LOADING_TIME);

      return () => clearTimeout(timer);
    }
  }, [src]);

  if (!src) {
    return;
  }

  if (isLoading) {
    return (
      <Box align="center" verticalAlign="middle">
        <SphereLoader size={isMobile ? 100 : 150} />
      </Box>
    );
  }

  return (
    <iframe
      src={src}
      title={`${storeName} - Live Preview`}
      className={`${s.iframe} ${isMobile ? s.mobile : s.desktop}`}
      sandbox="allow-scripts allow-same-origin allow-forms"
      scrolling="no" // This is the deprecated attribute
    />
  );
};
